import React, { useEffect, useState } from 'react';
import { redirect, useNavigate } from 'react-router-dom';

import "./iitBombayTechfestListing.css";
import GlobalLoader from '../../commanComponents/loaderCenter/loaderCenter';
import { clearData } from "../../../utils/localStorage";
import { IITBombayTechfestListingListService } from "../../../modules/services";
import BaseNavbar from '../../commanComponents/navbar/baseNavbar';
import StickyHeadTable from '../../commanComponents/table/basicTable';


const IITBombayTechfestListing = () => {
    const [dataMeta, setDataMeta] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    
    const getUserListData = (pageNo) => {
        (async () => {
            console.log({pagination: "true", page: pageNo})
            const responseData = await IITBombayTechfestListingListService({pagination: "true", page: pageNo});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setDataList([...dataList, ...responseData.data[0].results]);
                setDataMeta(responseData.data[0].links);
                setIsLoading(false);
            }
            else if (responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                window.location.href = 'https://fizrobotics.com';
            }
            else {
                clearData();
                window.location.href = 'https://fizrobotics.com';
            }
        })();
    }

    useEffect(() => {
        getUserListData(1);
    }, []);

    const handleLoadMore = () => { 
        if (dataMeta.next) {
            setIsLoading(true);
            getUserListData(dataMeta.current + 1);
        }
    }

    const tableColumns = [
        {
            id: 'serial_no',
            label: 'Serial No.',
            minWidth: 170
        },
        {
            id: 'first_name',
            label: 'First Name',
            minWidth: 170
        },
        {
            id: 'last_name',
            label: 'Last Name',
            minWidth: 170
        },
        {
            id: 'email',
            label: 'Email',
            minWidth: 170,
        },
        {
            id: 'phone',
            label: 'Phone no.',
            minWidth: 170,
        },
        {
            id: 'comments',
            label: 'Comments',
            minWidth: 170,
          },
        {
            id: 'created_at',
            label: 'Created At',
            minWidth: 170,
        }
    ];

    const formatDate = (dateString) => {
        const options = { 
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        };
    
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const handleFilterTableData = (dataList) => { 
        var responseList = []
        dataList.map((data, index) => responseList.push([
            data.id,
            index + 1,
            data.first_name,
            data.last_name,
            data.email,
            data.phone,
            data.comments,
            formatDate(data.created_at),
        ]))
        return responseList;
    } 

    return (
        <>
            <BaseNavbar />
            <h1 style={{textAlign: "center", margin: "20px"}}>IIT Bombay Techfest Client Listing</h1>
            <div className='school-list-main-container'>
                    <StickyHeadTable columns={tableColumns} dataList={dataList.length > 0 ? handleFilterTableData(dataList) : []} handleLoadMore={handleLoadMore} isPagination={true} />
                    {isLoading && <GlobalLoader />}
            </div>
        </>
    );
}

export default IITBombayTechfestListing;
